import { prop } from 'ramda';
import { ISapporoSearchRoom } from '@@sapporo/global/search/interface/ISapporoSearchRoom';
import { ISearchCapacity } from '@/models/Search/interfaces/ISearchCapacity';
import { IGlobalPlaceRoomFilter } from '@/models/GlobalPlace/interfaces/IGlobalPlaceFilter';

export const DEFAULT_CAPACITY_ADULT = 2;
export const DEFAULT_CAPACITY_CHILD = 0;

type RoomsQuery = [
  {
    adult?: number;
    children?: string[];
  },
];

export const capacityToRoom = ({ capacityAdult, capacityChildAges }: ISearchCapacity): IGlobalPlaceRoomFilter[] => {
  return [
    {
      adult: capacityAdult || DEFAULT_CAPACITY_ADULT,
      child: capacityChildAges || [],
    },
  ];
};

export const roomToCapacity = (room: ISapporoSearchRoom[]): ISearchCapacity => ({
  capacityAdult: room?.[0].adult || DEFAULT_CAPACITY_ADULT,
  capacityChild: room?.[0].child?.length || DEFAULT_CAPACITY_CHILD,
  capacityChildAges: room?.[0].child?.map(prop('age')) || [],
});

export const roomsQueryToCapaticy = (rooms: RoomsQuery): ISearchCapacity => ({
  capacityAdult: Number(rooms?.[0].adult || DEFAULT_CAPACITY_ADULT),
  capacityChild: rooms?.[0].children?.length || DEFAULT_CAPACITY_CHILD,
  capacityChildAges: rooms?.[0].children?.map(Number) || [],
});
